import React from "react"
const TeamManagementIcon = ({ size, className }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g id="building-02">
				<path
					id="Icon"
					d="M16.25 22.75V16.9C16.25 16.2933 16.25 15.9899 16.1319 15.7582C16.0281 15.5543 15.8623 15.3886 15.6585 15.2847C15.4268 15.1667 15.1234 15.1667 14.5167 15.1667H11.4833C10.8766 15.1667 10.5732 15.1667 10.3415 15.2847C10.1377 15.3886 9.97194 15.5543 9.86808 15.7582C9.75 15.9899 9.75 16.2933 9.75 16.9V22.75M3.25 7.58333C3.25 9.37826 4.70507 10.8333 6.5 10.8333C8.29493 10.8333 9.75 9.37826 9.75 7.58333C9.75 9.37826 11.2051 10.8333 13 10.8333C14.7949 10.8333 16.25 9.37826 16.25 7.58333C16.25 9.37826 17.7051 10.8333 19.5 10.8333C21.2949 10.8333 22.75 9.37826 22.75 7.58333M6.71667 22.75H19.2833C20.4968 22.75 21.1035 22.75 21.567 22.5138C21.9747 22.3061 22.3061 21.9747 22.5138 21.567C22.75 21.1035 22.75 20.4968 22.75 19.2833V6.71667C22.75 5.50322 22.75 4.8965 22.5138 4.43302C22.3061 4.02534 21.9747 3.69388 21.567 3.48615C21.1035 3.25 20.4968 3.25 19.2833 3.25H6.71667C5.50322 3.25 4.8965 3.25 4.43302 3.48615C4.02534 3.69388 3.69388 4.02534 3.48615 4.43302C3.25 4.8965 3.25 5.50322 3.25 6.71667V19.2833C3.25 20.4968 3.25 21.1035 3.48615 21.567C3.69388 21.9747 4.02534 22.3061 4.43302 22.5138C4.8965 22.75 5.50322 22.75 6.71667 22.75Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	)
}
export default TeamManagementIcon
